import { useEffect, useState } from "react";
import { FormControl, Select, MenuItem, Tooltip} from "@mui/material";
import { CoverageDescriptions } from "../../objects/coverageDescriptions";
import coverageSettings from "../../assets/coverages.json";

function CoverageLimitDropDown(props:any){
    const {
        lookupCoverages,
        coverage,
        currentCoverage,
        currentLimit,
        onLimitChange
    } = props;

    const[selectedLimit, setSelectedLimit] = useState<string>(currentLimit);
    const coverageName = coverage.coverage;
    const setting = coverageSettings.policy.coverages.find(m=>m.coverage == coverageName);

    function onPolicyLimitChange(coverage:string, limit: string, e:any){
        setSelectedLimit(limit);

        onLimitChange(coverage, limit, e);
    }

    function renderEmptyLimitSelection(){
        if(setting?.allowRejection ?? false) {
            return <MenuItem value={currentCoverage.emptyLimit}>No Coverage</MenuItem>;
        }
    }

    return (
        <>
        <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-6 xl:col-span-6">
            <label className="font-medium mb-10 text-gray-600 text-sm">
            <Tooltip title={CoverageDescriptions.map(coverage.coverage)}>
                                    <span className="hover:cursor-pointer">{coverage.coverageDescription}</span>
                                  </Tooltip>
                </label> 
            <FormControl fullWidth>
                <Select
                    id={"ddl"+coverage.coverage}
                    name={coverage.coverage}
                    value={selectedLimit}
                    displayEmpty
                    onChange={(e:any) => { 
                        onPolicyLimitChange(coverage.coverage, e.target.value, e);
                    }}
                    >
                            <MenuItem selected={true} value="">
                            <em>select the value</em>
                        </MenuItem>


                        {renderEmptyLimitSelection()}

                        
                    {
                        lookupCoverages.map((v2:any, i:any) =>{
                            if(coverage.coverage == v2.coverage){
                                var isSelected = currentCoverage?.limit === v2.limitValue;
                                return <MenuItem value={v2.limitValue}>{v2.displayLimit}</MenuItem>
                                
                            }
                        })
                    }
                </Select>
            </FormControl>
        </div>
        </>
    );
}

export default CoverageLimitDropDown;